import { ListPage } from '@components/molecules';
import { TextFieldElement } from 'react-hook-form-mui';
import API from '@apps/localization/services/country';
import { ModelProps } from '@/types';
import {
  CountrySchema,
  CountrySearchSchema,
} from '@apps/localization/schemas/country';
import { GridColDef } from '@mui/x-data-grid';
import { JSX } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { YesNoAutocompleteElement } from '@/components/atoms';
import AsyncAutocompleteElement from '@/components/atoms/asyncautocomplete';
import APIRegion from '@apps/localization/services/region';

export default function ObjectListPage(modelProps: ModelProps): JSX.Element {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('Name'),
      flex: 1,
    },
    {
      field: 'region',
      headerName: t('Region'),
      width: 150,
      valueFormatter: (params: { id: number; label: string }) => {
        return params.label;
      },
    },
    {
      field: 'is_active',
      headerName: t('Is Active?'),
      width: 120,
      type: 'boolean',
    },
  ];

  return (
    <ListPage
      schema={CountrySchema}
      schemaSearch={CountrySearchSchema}
      title={t('Country')}
      api={API}
      columns={columns}
      modelProps={modelProps}
      initialState={{
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }],
        },
      }}
    >
      <Grid size={{ xs: 12, md: 3 }}>
        <TextFieldElement name="search" label={t('Search')} fullWidth />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <AsyncAutocompleteElement
          api={APIRegion.select}
          name="region"
          label={t('Region')}
          // required
        />
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <YesNoAutocompleteElement name="is_active" label={t('Is Active?')} />
      </Grid>
    </ListPage>
  );
}
